import { render, staticRenderFns } from "./activityFormTwo.vue?vue&type=template&id=5fc84712&"
import script from "./activityFormTwo.vue?vue&type=script&lang=js&"
export * from "./activityFormTwo.vue?vue&type=script&lang=js&"
import style0 from "./activityFormTwo.vue?vue&type=style&index=0&id=5fc84712&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports